import { axiosAzure } from '../interceptors/axios-azure';

const { VITE_API_BASE_URL_MEG } = typeof import.meta !== 'undefined' ? import.meta.env : process.env;


export const httpGetVerifyClrEnrlmnt = (sessionToken) => {
  let url = `${VITE_API_BASE_URL_MEG}/verify/${sessionToken}`;
  return axiosAzure({ method: 'get', url });
};

export const httpGetRedirectClrEnrlmnt = () => {
  const url = `${VITE_API_BASE_URL_MEG}/redirect`;
  return axiosAzure({ method: 'get', url });
};
